export const DDC_PAGE_INIT_VIEWPORT_WIDGETS =
	'ddc.page.initialPageWidgetsInView';
const pageNamesToInclude = ['INDEX'];

function initialPageWidgetsInView() {
	if (
		!pageNamesToInclude.includes(
			window?.DDC?.dataLayer?.page?.pageInfo?.pageName
		)
	)
		return {};
	const inViewportWidgets = Array.from(
		document.querySelectorAll('#page-body [data-widget-name]')
	)
		.filter((widget) => {
			const rect = widget.getBoundingClientRect();
			return (
				rect.bottom > 0 &&
				rect.top <
					(window.innerHeight ||
						document.documentElement.clientHeight)
			);
		})
		.map(
			(widget) =>
				`${widget.getAttribute('data-widget-id')}:${widget.getAttribute(
					'data-widget-name'
				)}`
		);
	if (inViewportWidgets.length) {
		return {
			eventType: DDC_PAGE_INIT_VIEWPORT_WIDGETS,
			eventData: {
				widgets: inViewportWidgets
			}
		};
	} else {
		return {};
	}
}
export default initialPageWidgetsInView;
